import { IStyle, mergeStyles, keyframes } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../../common/styles/common.styles';

export const RecordingStateIconName = 'MicrophoneListeningIcon.svg';
export const PausedStateIconName = 'MicrophonePauseIcon.svg';

const micWidgetHeightPx = 48;
const micWidgetWidthPx = 48;
const micWidgetContainerHeightPx = 70;
const micWidgetContainerWidthPx = 70;

export const getMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    background: 'none',
    height: `${micWidgetHeightPx}px`,
    width: `${micWidgetWidthPx}px`,
    cursor: 'pointer',
    padding: 0,
    boxSizing: 'unset',
  };

  return style;
};

export const getDisabledMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    opacity: 0.6
  };

  return style;
};

export const getEnabledMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    opacity: 1.0
  };

  return style;
};

export const getRecordingMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    borderRadius: '50%',
    border: `3px solid ${AppLayoutSettings.getAppColorContainer().recordingIconRingsColor.value}`
  };

  return style;
};

const initialAnimation: string = keyframes({
  from: { transform: `scale(1)` },
  to: { transform: `scale(1.57)` },
});

const outerRingWaiting = keyframes({
  from: { transform: `scale(1.57)` },
  "50%": { transform: `scale(1)` },
  to: { transform: `scale(1.57)` },
});

export const getPulseRingsStyle = () : string => {
    return mergeStyles({
      position: 'absolute',
      borderRadius: '50%',
      zIndex: -1,
      height: `${micWidgetHeightPx}px`,
      width: `${micWidgetWidthPx}px`,
      background: AppLayoutSettings.getAppColorContainer().recordingIconRingsColor.value,
      animation:  `${initialAnimation} 500ms forwards, ${outerRingWaiting} 2s 500ms infinite`,
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    });
  }

export const getPausedMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    border: 0
  };

  return style;
};

export const getMicWidgetIconStyles = (recorderIconName: string): string => {
  // By default both the icons are not aligning in center, looks like some defect in the icon.
  // Therefore a forced set of top padding and text indentation is required to force the icons
  // in vertical and horizontal center.
  let topPaddingPx: string = '0px';
  let textIndentPx: string = '0px';
  if (recorderIconName == PausedStateIconName) {
    topPaddingPx = '5px';
    textIndentPx = '0px';
  } else if (recorderIconName == RecordingStateIconName) {
    topPaddingPx = '0px';
    textIndentPx = '0px';
  }

  return mergeStyles({
    fontSize: '30px',
    paddingTop: topPaddingPx,
    textIndent: textIndentPx,
    });
};

export const getMicWidgetContainerCSSProperties = (): React.CSSProperties => {
  const CSSProperties: React.CSSProperties = {
    height: `${micWidgetContainerHeightPx}px`,
    width: `${micWidgetContainerWidthPx}px`,
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  return CSSProperties;
};

